import { Controller } from "@hotwired/stimulus"
import { post } from '@rails/request.js'

export default class extends Controller {
  static targets = ['teachingLevelId', 'modalityId', 'poleId', 'ingressTypeId', 'durationId']

  connect (){
  }

  btnEdit (e) {
    e.currentTarget.textContent = 'Salvar';
    this.activeEdit();

  }

  activeEdit () {
    this.teachingLevelIdTarget.disabled = !this.teachingLevelIdTarget.disabled
    this.modalityIdTarget.disabled = !this.modalityIdTarget.disabled
    this.poleIdTarget.disabled = !this.poleIdTarget.disabled
    this.ingressTypeIdTarget.disabled = !this.ingressTypeIdTarget.disabled
    this.durationIdTarget.disabled = !this.durationIdTarget.disabled
  }

  disableEdit () {
    this.teachingLevelIdTarget.disabled = true
    this.modalityIdTarget.disabled = true
    this.poleIdTarget.disabled = true
    this.ingressTypeIdTarget.disabled = true
    this.durationIdTarget.disabled = true
  }
}
